import React, { useContext } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BuildContext } from "../../context/BuildSpotlightState";
import Color from "color";

const TypeItem = ({ item }) => {
  const {
    setStage,
    setType,
    generateRandomColor,
    setSecondaryColor,
    setPrimaryColor,
    setLastCompleted,
  } = useContext(BuildContext);

  const handleClick = () => {
    const randomColor = generateRandomColor();
    setType(item.type);
    updateColors(randomColor);
    setStage(1);
    setLastCompleted(1);
  };

  const updateColors = (color) => {
    const newColor = Color(color);
    const contrast = newColor.contrast(Color("#FFF"));
    const contrastLimit = 2;

    setPrimaryColor(color);
    setSecondaryColor(contrast > contrastLimit ? "#FEFEFE" : "#0A0A0A");
  };

  return (
    <div className={container} onClick={handleClick}>
      <div className="box">
        <img src={item.icon} />
        <div className="info">
          <h3>{item.title}</h3>
          <p>{item.desc}</p>
        </div>
      </div>
      <FontAwesomeIcon className="chevron" icon="chevron-right" />
    </div>
  );
};

export default TypeItem;

const container = css`
  cursor: pointer;
  padding: ${boxStyles.standardPadding};
  border-bottom: 1px solid ${colors.lineBreak};
  display: flex;
  align-items: center;
  justify-content: space-between;

  .box {
    display: flex;
    align-items: center;

    img {
      font-size: 20px;
      color: ${colors.brandColor};
      padding-right: 5px;
      width: 25px;
    }

    .info {
      padding: 0 ${boxStyles.standardPadding};
      
      h3 {
        color: ${colors.titleColor};
        font-size: ${textSizes.subtitle};
        padding-bottom: 4px;
      }
      
      p {
        color: ${colors.subtitleColor};
        font-size: ${textSizes.intermediate};
      }
    }
  }

  .chevron {
    color: ${colors.placeholderText};
  }
  .tier {
    padding: 4px 8px;
    border-radius: 40px;
    text-transform: uppercase;
    color: white;
    font-size: ${textSizes.normal};
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    padding: ${boxStyles.standardPadding} 30px;
  }
`;
